export function farloUiRevolverCarousel(element) {
    let flkty = "";

            flkty = new Flickity(element, {
                cellAlign: 'left',
                pageDots: false,
                prevNextButtons: false,
                wrapAround: false,
                groupCells: false,
                freeScroll: false,
                draggable: true,
                dragThreshold: 1,
                autoPlay:6000,
            });



}
